import { HTTPHeaders, httpLink, loggerLink } from '@trpc/client';

import { Config } from '@sternum/web/config';

import { appStorage } from '../appStorage';

import { trpc } from './trpc';

// msw-trpc library that is used for mocking trpc endpoints doesnt support batching as of September 2023.
// Besides that, batching has annoying issue related to GET url size limitation, and currently
// its not possible to switch to POST on demand, so disabling batching for now.
// Related issue: https://github.com/trpc/trpc/issues/3910
const baseLink = Config.useMockServer || Config.mode === 'test' ? httpLink : httpLink; // httpBatchLink

export const trpcClient = trpc.createClient({
  links: [
    loggerLink({
      enabled: () => Config.mode === 'development' || Config.mode === 'test',
    }),
    baseLink({
      url: `${Config.apiUrl}/trpc`,
      async headers({ op }) {
        const headers: HTTPHeaders = {};

        const token = appStorage.getToken();

        if (token) {
          headers.authorization = `Bearer ${token}`;
        }

        const clientId = (op.context.clientId as string) || window.location.pathname.split('/')[1];

        if (clientId) {
          headers['x-sternum-client'] = clientId;
        }

        return headers;
      },
    }),
  ],
});
